"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _net = require("./graphql-types/net");
Object.keys(_net).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _net[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _net[key];
        }
    });
});
